import React, { memo } from 'react'

import { IFormDropdownProps } from 'cng-common/features/form/components/formDropdown/models'
import {
  IAudienceCondition,
  VisualAudienceExtended,
} from 'core/components/shared/ui/VisualAudienceExtended'
import { IPartnerTerritory } from 'onboarding/classes/models/partnerTerritoryModels'
import {
  FormLocationTreeAdapter,
  OnboardingFormDropdownAdapter,
} from 'onboarding/components/ui/visualAudienceAdapters'

import { TFormLocationTreeExtended } from '../formLocationTreeExtended/FormLocationTreeExtended'
import { TDropdownsCruds } from '../models'
import { PartnerTerritoryInfo } from '../partnerTerritoryInfo/PartnerTerritoryInfo'
import styles from '../RequestorFill.module.scss'

interface IProps {
  formKey: string
  partnerTerritory: IPartnerTerritory
  cruds: TDropdownsCruds
  leadBU: string
  hpSigningEntity: string
  territorySaleSelected: string[]
  territoryOfSaleRoot?: string
  writeAudience: IAudienceCondition
  isDisabled?: boolean
}

export const FormFields = memo(
  ({
    formKey,
    partnerTerritory,
    cruds,
    writeAudience,
    leadBU,
    hpSigningEntity,
    territorySaleSelected,
    territoryOfSaleRoot,
    isDisabled,
  }: IProps) => {
    return (
      <div>
        <div className={styles.wrapper}>
          <VisualAudienceExtended<IFormDropdownProps<any>>
            component={OnboardingFormDropdownAdapter}
            write={writeAudience}
            formKey={formKey}
            label={'Lead BU'}
            field={'LeadBU'}
            source={cruds.leadBU}
            defaultValue={leadBU}
            caption={'en'}
            isDisabled={isDisabled}
            isRequired
          />
        </div>

        <div className={styles.wrapper}>
          <VisualAudienceExtended<IFormDropdownProps<any>>
            component={OnboardingFormDropdownAdapter}
            write={writeAudience}
            formKey={formKey}
            label={'HP Signing Entity'}
            field={'HPSigningEntity'}
            source={cruds.hpSigningEntityEmea}
            defaultValue={hpSigningEntity}
            caption={'en'}
            isDisabled={isDisabled}
            isRequired
          />
        </div>

        <div className={styles.wrapper}>
          <PartnerTerritoryInfo />
        </div>

        <VisualAudienceExtended<TFormLocationTreeExtended>
          write={writeAudience}
          component={FormLocationTreeAdapter}
          formKey={formKey}
          partnerTerritory={partnerTerritory}
          label={'Territory of Sale'}
          field={'TerritorySaleISO'}
          defaultValue={territorySaleSelected}
          root={territoryOfSaleRoot}
          isDisabled={isDisabled}
          hideHpOrg
          isRequired
        />
      </div>
    )
  }
)
